import { IPipelineRun } from '../../../core/modules/pipelines/pipelines.model';

/** Flatten parent + children into sibling rows (drops `children` field). */
export const flattenForTab = (parent: IPipelineRun): IPipelineRun[] => {
  const children = (parent.children ?? []).map((c) => ({ ...c, children: undefined }));

  return [{ ...parent, children: undefined }, ...children];
};

/** Synthesize a "currently running" row from the live orchestrator stage. */
export const liveRunForActivity = (
  activityName: string | null | undefined,
  current: IPipelineRun | null
): IPipelineRun | null => {
  if (!activityName || !current) {
    return null;
  }

  const stage = current.stages?.find((s) => s.id === activityName && s.status === 'running');

  if (!stage) {
    return null;
  }

  const startedAt = stage.startedAt ?? current.startedAt ?? null;
  const durationSec = startedAt
    ? Math.max(0, Math.round((Date.now() - new Date(startedAt).getTime()) / 1000))
    : null;

  return {
    runId: current.runId,
    status: 'running',
    startedAt,
    endedAt: null,
    durationSec,
    activityName,
    errorMessage: null
  };
};
